import { api } from '@/api/api';
import { util, wait } from '@/api/util';
import { apis, inWindow } from '@/config';
export class MailAttactmentCacher {
    constructor(dbHelper) {
        this.shouldCacheToInstallDir = false;
        this.cacheBasePath = undefined;
        this.customMailCachePath = undefined;
        this.defaultCachepath = undefined;
        this.systemApi = api.getSystemApi();
        this.db = api.getNewDBApi();
        this.mailContentDbHelper = dbHelper;
        this.fileApi = api.getFileApi();
        this.loggerHelper = api.requireLogicalApi(apis.loggerApiImpl);
        this.fileDownloadConf = {
            taskIds: [],
            taskMap: new Map(),
            runningTaskId: '',
            fileDownloadDir: {},
            taskEnable: false,
        };
        this.getShouldUseInstallDir().then(res => {
            this.shouldCacheToInstallDir = res;
            if (res) {
                this.getExeDir().then((exePath) => {
                    if (!exePath)
                        return;
                    this.cacheBasePath = exePath;
                });
            }
        });
    }
    getExePath() {
        return window.electronLib.appManage.getPath('exe');
    }
    async setMailCachePath(path) {
        this.customMailCachePath = path;
    }
    async getExeDir() {
        return this.getExePath().then((exeDir) => {
            if (exeDir && exeDir.includes('.exe') && exeDir.includes('\\')) {
                const lastPathSplitInx = exeDir.lastIndexOf('\\');
                return exeDir.substring(0, lastPathSplitInx);
            }
            return '';
        });
    }
    async getShouldUseInstallDir() {
        if (!inWindow() || !window.electronLib)
            return false;
        const isWin = !window.electronLib.env.isMac;
        if (isWin) {
            const exePath = await this.getExePath();
            if (exePath && exePath.toLowerCase().indexOf('c:') === 0) {
                return false;
            }
            return true;
        }
        return false;
    }
    filterDownloadFile(file) {
        const { fileType, inlined, fileSize } = file;
        if (!fileType || fileType === 'ics') {
            return false;
        }
        const INLINE_MAX_SIZE = 20 * 1024 * 1024;
        if (inlined && util.isImage(fileType) && fileSize < INLINE_MAX_SIZE) {
            return true;
        }
        const FILE_MAX_SIZE = 3 * 1024 * 1024;
        if (!inlined && fileSize < FILE_MAX_SIZE) {
            return true;
        }
        return false;
    }
    getAttachmentPart(v) {
        return (v.id ? String(v.id) : v.cloudIdentity) || '_' + (1000 * Math.random()).toFixed(2);
    }
    buildFileInfo(it, filesMap, idSet) {
        var _a, _b, _c, _d, _e;
        if (!this.systemApi.isElectron()) {
            return;
        }
        if (it.isThread) {
            return;
        }
        if (((_a = it.entry) === null || _a === void 0 ? void 0 : _a.folder) === 2 || ((_b = it.entry) === null || _b === void 0 ? void 0 : _b.isDraft)) {
            return;
        }
        if (Array.isArray((_c = it.entry) === null || _c === void 0 ? void 0 : _c.attachment) && ((_d = it.entry) === null || _d === void 0 ? void 0 : _d.attachment.length) > 0) {
            (_e = it.entry) === null || _e === void 0 ? void 0 : _e.attachment.filter(this.filterDownloadFile).forEach(v => {
                var _a;
                if (v.fileOriginUrl && !idSet.has(v.fileOriginUrl)) {
                    idSet.add(v.fileOriginUrl);
                    const targetTask = {
                        file: v,
                        mailInfo: {
                            fid: (_a = it.entry) === null || _a === void 0 ? void 0 : _a.folder,
                            mid: it.id,
                            part: this.getAttachmentPart(v),
                        },
                    };
                    filesMap.set(v.fileOriginUrl, targetTask);
                }
            });
        }
    }
    async putFileIgnoreExist({ idSet, data, taskType = 'default', reserveKeys = [], _account }) {
        if (!this.systemApi.isElectron()) {
            return [];
        }
        if (data.size === 0) {
            return [];
        }
        const ids = Array.from(idSet);
        const delIds = new Set();
        const validOriginData = [];
        const originData = (await this.db.getByIndexIds({ dbName: 'fileop', tableName: 'file', _dbAccount: _account }, 'fileOriginUrl', ids)).filter(v => !!v);
        originData.forEach(v => {
            if (!v.filePath || !window.electronLib.fsManage.isExist(v.filePath)) {
                if (v.fid) {
                    delIds.add(v.fid);
                }
            }
            else {
                validOriginData.push(v);
            }
        });
        if (delIds.size > 0) {
            await this.db.deleteById({ dbName: 'fileop', tableName: 'file', _dbAccount: _account }, [...delIds]).catch();
        }
        if (validOriginData && validOriginData.length > 0) {
            this.mailContentDbHelper.deleteExistData('fileOriginUrl', data, validOriginData, reserveKeys);
        }
        if (data.size > 0) {
            const remainData = [];
            data.forEach(v => {
                remainData.push(v);
            });
            this.storeDownloadTasks(remainData, taskType, _account);
            return remainData;
        }
        return Promise.resolve([]);
    }
    storeDownloadTasks(files, taskType = 'default', _account) {
        const type = taskType === 'push' ? 'pushTask' : 'defaultTask';
        files.forEach(task => {
            const { file } = task;
            const id = file.fileOriginUrl;
            if (id) {
                if (type === 'pushTask') {
                    setTimeout(() => {
                        this.insertDownloadTask(id, type, task);
                    }, 100);
                }
                else {
                    this.insertDownloadTask(id, type, task);
                }
            }
        });
        this.saveFilesInMail(false, taskType, _account).then();
    }
    insertDownloadTask(id, taskType, task) {
        var _a, _b;
        const { taskIds, runningTaskId, taskMap } = this.fileDownloadConf;
        if (id === runningTaskId || taskMap.has(id) || ((_a = task === null || task === void 0 ? void 0 : task.file) === null || _a === void 0 ? void 0 : _a.fileSize) < 1000 ** 2 * 10) {
            return;
        }
        const index = taskIds.indexOf(id);
        if (index === -1) {
            if (taskType === 'defaultTask') {
                taskIds.push(id);
            }
            else {
                taskIds.unshift(id);
            }
            taskMap.set(id, Object.assign(Object.assign({}, task), { taskType }));
        }
        else {
            console.log('[file auto download] file download task exist', taskType, id);
            if (taskType === 'pushTask') {
                taskIds.splice(index, 1);
                if (((_b = task === null || task === void 0 ? void 0 : task.file) === null || _b === void 0 ? void 0 : _b.fileSize) < 1000 ** 2) {
                    taskIds.unshift(id);
                }
                else {
                    taskIds.splice(1, 0, id);
                }
            }
        }
    }
    async saveFilesInMail(taskEnable, taskType = 'default', _account) {
        const isLowMemoryMode = this.systemApi.getIsLowMemoryModeSync();
        const isBgPage = window.isBridgeWorker;
        const isElectron = this.systemApi.isElectron();
        if (!inWindow() || !isElectron || isLowMemoryMode || !isBgPage) {
            return;
        }
        if (taskEnable) {
            this.fileDownloadConf.taskEnable = true;
        }
        const startRun = this.fileDownloadConf.taskEnable || taskType === 'push';
        if (!startRun) {
            console.log('[file auto download] not allowed at the moment');
            return;
        }
        const type = taskType === 'push' ? 'pushTask' : 'defaultTask';
        const { runningTaskId, taskIds } = this.fileDownloadConf;
        if (runningTaskId) {
            console.log('[file auto download] ', type, 'already running', runningTaskId);
            return;
        }
        console.log('[file auto download] ---- ', type, '---- start', taskIds);
        await this.saveFilesInMailCall(_account);
    }
    async saveFilesInMailCall(_account) {
        const { taskIds, taskMap } = this.fileDownloadConf;
        const taskId = taskIds.shift();
        if (taskId) {
            this.fileDownloadConf.runningTaskId = taskId;
            const task = taskMap.get(taskId);
            if (task) {
                try {
                    const { file, mailInfo } = task;
                    const dirPath = await this.mkDownloadDir(file.inlined ? 'inline' : 'regular', { fid: mailInfo.fid, mid: mailInfo.mid });
                    console.log('[file auto download] ---- stage1 ---- prepare dir ', dirPath);
                    const originFilePath = this.getDownloadFileName(dirPath, file, false);
                    const toDownload = await this.fileDownloadLastCheck(taskId, originFilePath, _account);
                    if (toDownload) {
                        const filePath = this.getDownloadFileName(dirPath, file, true);
                        console.log('[file auto download] ---- stage2 ---- download start filePath ', filePath);
                        const defaultCachePath = this.getDefaultCachePathByAttachment(file.inlined ? 'inline' : 'regular', { fid: mailInfo.fid, mid: mailInfo.mid, _account });
                        console.log('[file auto download] ---- stage2 ---- download start defaultCachePath ', defaultCachePath);
                        const result = await this.fileApi.download(Object.assign(Object.assign({}, file), { filePath, fallbackFilePath: defaultCachePath }), { _account });
                        console.log('[file auto download] ---- stage3 -- save succeed ', result);
                        this.loggerHelper.track('auto_download_result', { task, result });
                    }
                    else {
                        console.log('[file auto download] file already downloaded', file);
                    }
                    const nextTaskId = taskIds[0];
                    const nextTask = nextTaskId ? taskMap.get(nextTaskId) : null;
                    const sleepTime = nextTask && nextTask.taskType === 'pushTask' ? 3000 : 60000;
                    console.log('[file auto download] ---- stage4 -- will wait ', sleepTime / 1000, ' s');
                    await wait(sleepTime);
                }
                catch (ex) {
                    console.error('[file auto download] error', ex);
                    this.loggerHelper.track('auto_download_error', { task, ex });
                }
            }
            await this.saveFilesInMailCall(_account);
        }
        else {
            this.fileDownloadConf.runningTaskId = '';
            console.log('[file auto download] ---- finished');
        }
    }
    setDefaultCachePath(path) {
        this.defaultCachepath = path;
    }
    getDefaultCachePathByAttachment(type, config) {
        const currentUser = this.systemApi.getCurrentUser(config === null || config === void 0 ? void 0 : config._account);
        const userPath = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) ? util.replaceInvalidFileChar(currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) : 'unknown';
        const { fid = 100001, mid } = config;
        const midDir = util.replaceInvalidFileChar(mid);
        const dirPath = window.electronLib.fsManage.normalizePath(`${this.defaultCachepath}/${userPath}/${type}/${fid}/${midDir}`);
        return dirPath;
    }
    async mkDownloadDir(type, config, fallbackToDefault = false) {
        const { fid = 100001, mid, _account } = config;
        const currentUser = this.systemApi.getCurrentUser(_account);
        const userPath = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) ? util.replaceInvalidFileChar(currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) : 'unknown';
        const userDir = this.fileDownloadConf.fileDownloadDir[userPath];
        if (userDir && userDir[type] && userDir[type][fid] && userDir[type][fid][mid]) {
            return userDir[type][fid][mid];
        }
        const midDir = util.replaceInvalidFileChar(mid);
        const dirPath = window.electronLib.fsManage.normalizePath(`${this.customMailCachePath ? '' : 'download'}/${userPath}/${type}/${fid}/${midDir}`);
        let dir = '';
        try {
            dir = await window.electronLib.fsManage.mkDir(dirPath, this.customMailCachePath || this.cacheBasePath);
        }
        catch (ex) {
            console.error('mkDir error', ex);
            const downDirPath = window.electronLib.fsManage.normalizePath(`download/${dirPath}`);
            if (fallbackToDefault && this.cacheBasePath && this.customMailCachePath && this.customMailCachePath.includes(this.cacheBasePath)) {
                dir = await window.electronLib.fsManage.mkDir(downDirPath, '');
            }
            else {
                if (this.customMailCachePath) {
                    if (!fallbackToDefault) {
                        dir = await window.electronLib.fsManage.mkDir(downDirPath, this.cacheBasePath);
                    }
                    else {
                        if (this.cacheBasePath) {
                            if (this.customMailCachePath.includes(this.cacheBasePath)) {
                                dir = await window.electronLib.fsManage.mkDir(downDirPath, '');
                            }
                            else {
                                dir = await window.electronLib.fsManage.mkDir(downDirPath, this.cacheBasePath);
                            }
                        }
                        else {
                            dir = await window.electronLib.fsManage.mkDir(downDirPath, '');
                        }
                    }
                }
                else {
                    if (fallbackToDefault && this.cacheBasePath) {
                        dir = await window.electronLib.fsManage.mkDir(dirPath, '');
                    }
                    else {
                        throw ex;
                    }
                }
            }
        }
        if (!this.fileDownloadConf.fileDownloadDir[userPath]) {
            this.fileDownloadConf.fileDownloadDir[userPath] = {
                inline: {},
                regular: {},
            };
        }
        if (!this.fileDownloadConf.fileDownloadDir[userPath][type][fid]) {
            this.fileDownloadConf.fileDownloadDir[userPath][type][fid] = {};
        }
        this.fileDownloadConf.fileDownloadDir[userPath][type][fid][mid] = dir;
        return dir;
    }
    getDownloadFileName(dirPath, file, rename = true) {
        const formatFileName = file.fileName.replace(/[:*\^\|'"`~]/gi, '_');
        const extFileName = /^.+(\.[a-zA-Z0-9]+)$/.test(formatFileName) ? formatFileName : `${formatFileName}.${file.fileType}`;
        const fileName = rename ? window.electronLib.fsManage.setDownloadFileName(dirPath, extFileName, undefined, 2000) : extFileName;
        return `${window.electronLib.fsManage.normalizePath(dirPath + '/')}${fileName}`;
    }
    async fileDownloadLastCheck(fileOriginUrl, filePath, _account) {
        if (!this.systemApi.isElectron()) {
            return false;
        }
        const fileExist = window.electronLib.fsManage.isExist(filePath);
        if (!fileExist) {
            return true;
        }
        const dbData = (await this.db.getByIndexIds({ dbName: 'fileop', tableName: 'file', _dbAccount: _account }, 'fileOriginUrl', [fileOriginUrl])).filter(v => !!v);
        if (dbData.length === 0) {
            return true;
        }
        const dbFilePath = dbData[0].filePath;
        const res = dbFilePath !== filePath;
        if (dbFilePath && res) {
            try {
                await window.electronLib.fsManage.remove(dbFilePath);
            }
            catch (ex) {
                console.error('remove file error', ex);
            }
        }
        return res;
    }
}
